module.exports = __webpack_public_path__ + "98ed7f7bd18d4a8ce91d96dced567f01.svg";